<template>
  <div class="backtest-macd-view">
    <BacktestMACD />
  </div>
</template>

<script>
import BacktestMACD from '@/components/quant-trading/BacktestMACD.vue'

export default {
  name: 'BacktestMACDView',
  components: { BacktestMACD }
}
</script>

<style scoped>
.backtest-macd-view {
  width: 100%;
  height: 100%;
}
</style>
